import { render } from "./LoginCard.vue?vue&type=template&id=2b153bed&scoped=true&ts=true"
import script from "./LoginCard.vue?vue&type=script&lang=ts"
export * from "./LoginCard.vue?vue&type=script&lang=ts"

import "./LoginCard.vue?vue&type=style&index=0&id=2b153bed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b153bed"]])

export default __exports__